module.exports = __webpack_public_path__ + "static/flags/YI-947e8e2bd24fdf649812c78414ec1e5a.gif";